import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  IconButton,
  Stack,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, incrementQty, decrementQty } from "../../cart/sliceCart";
// Icons
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import NoImageIcon from "@mui/icons-material/Image"; // Fallback Icon

const ProductCard = ({ product, baseUrl }) => {
  const { ItmCd, VATRSP, Stock, Name2, Packing, ArticleNo } = product;
  const dispatch = useDispatch();
  const { cartList } = useSelector((state) => state.sliceCart);
  const cartItem = cartList?.find((item) => item.ItmCd === ItmCd);

  // Image fallback state
  const [imageError, setImageError] = useState(false);

  const imageUrl = `${baseUrl}Products/${ArticleNo}.jpg`;

  return (
    <Card
      sx={{
        width: { xs: 280, sm: "100%" },
        borderRadius: 4,
        boxShadow: 4,
        overflow: "hidden",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "scale(1.02)",
          boxShadow: 6,
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Product Image */}
      {imageError ? (
        <Box
          sx={{
            height: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
          }}
        >
          <NoImageIcon sx={{ fontSize: "4rem", color: "gray" }} />
        </Box>
      ) : (
        <CardMedia
          component="img"
          image={imageUrl}
          alt={Name2}
          loading="lazy"
          onError={() => setImageError(true)}
          sx={{
            height: 200,
            objectFit: "contain",
            backgroundColor: "transparent",
            paddingTop: "8px",
          }}
        />
      )}
      {/* Product Details */}
      <CardContent sx={{ textAlign: "center", p: 1.5 }}>
        {/* Product Name */}
        <Typography
          variant="subtitle1"
          component="div"
          gutterBottom
          sx={{
            fontWeight: "bolder",
            fontSize: "0.8rem",
            color: "text.primary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {Name2}
        </Typography>
        {/* Price and Stock */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          px={1}
        >
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontWeight: "bold" }}
          >
            AED {Number(VATRSP).toFixed(2)}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: Stock > 0 ? "success.main" : "error.main",
              fontWeight: 500,
            }}
          >
            {Stock > 0 ? `Stock ${Stock}` : ""}
          </Typography>
        </Box>
        {/* Packing */}
        <Typography
          variant="caption"
          color="text.secondary"
          gutterBottom
          sx={{
            fontSize: "0.75rem",
            fontStyle: "italic",
            fontWeight: "bold",
          }}
        >
          Packing: {Packing}
        </Typography>
        {/* Cart Actions */}
        <Stack direction="row" justifyContent="center" mt={1.5}>
          {cartItem ? (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                width: "100%",
                maxWidth: 140,
                backgroundColor: "#f9f9f9",
                borderRadius: 16,
                p: 0.3,
                boxShadow: 1,
              }}
            >
              <IconButton
                color="error"
                size="small"
                onClick={() => dispatch(decrementQty(ItmCd))}
              >
                {cartItem.qty === 1 ? <DeleteIcon /> : <RemoveIcon />}
              </IconButton>
              <Typography variant="subtitle2" fontWeight="bold">
                {cartItem.qty}
              </Typography>
              <IconButton
                color="success"
                size="small"
                onClick={() => dispatch(incrementQty(ItmCd))}
              >
                <AddIcon />
              </IconButton>
            </Box>
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={() => dispatch(addToCart(product))}
              sx={{
                boxShadow: 1,
                backgroundColor: "primary.main",
                "&:hover": { backgroundColor: "primary.dark" },
              }}
            >
              Add to Cart
            </Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
